import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import Hero from '../components/hero';
import Featured from './featured';
import WhatsHot from './whatshot';
import Recommended from './recommended';
import Trending from './trending';
import NearMe from './nearme';
import Directory from './directory';
import usePublisherInit from '../../store/models/publisher/usePublisherInit';

function WorldPage() {
    const { subscriber, onSync, onShare } = useOutletContext();
    const directoryRef = useRef(null);
    const whatsHotRef = useRef(null);
    usePublisherInit();

    function handleBrowse() {
        directoryRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    function handleWhatsHot() {
        whatsHotRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <Box>
            <Hero onBrowse={handleBrowse} onWhatsHot={handleWhatsHot} />

            <Featured onSync={onSync} onShare={onShare} />

            <Box ref={whatsHotRef}>
                <WhatsHot onSync={onSync} onShare={onShare} />
            </Box>

            <Recommended subscriber={subscriber} onSync={onSync} onShare={onShare} />

            <Trending onSync={onSync} onShare={onShare} />

            <NearMe onSync={onSync} onShare={onShare} />

            <Box ref={directoryRef}>
                <Directory onSync={onSync} onShare={onShare} />
            </Box>
        </Box>
    );
}

export default WorldPage;
